import { render, staticRenderFns } from "./CoCreation.vue?vue&type=template&id=199be4da&scoped=true"
import script from "./CoCreation.vue?vue&type=script&lang=js"
export * from "./CoCreation.vue?vue&type=script&lang=js"
import style0 from "./CoCreation.vue?vue&type=style&index=0&id=199be4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199be4da",
  null
  
)

export default component.exports